import { AlarmLevel } from './alarm-level';

export class ElementSettings {
    id?: string;
    mimicId: string;
    elementId: string;
    channelTag: string;
    channelIsDigital: boolean;
    activeFlags?: ActiveFlags;
    ranges?: RangeSetting[];
    disabledStatus?: DisabledStatus;
    flashingStatus?: FlashingStatus;
    toggleState?: ToggleStatus;
    buttonAction?: ButtonAction;
    elementName?: string;
    tankType?: string;
    selectNumber?: number;
    cylinderCount?: number;
    filterType?: string;
    pumpType?: string;
    valveSetting?: ValveSetting;
}

export class ValveSetting {
    channleListIsDigital: boolean;
    way: string;
    openChannel: ValveChannel;
    flashChannel: ValveChannel;
    closeChannel: ValveChannel;
}

export class ValveChannel {
    tag: string;
    status: 0 | 1;
}

export class Flags {
    alarm;
    cancelManual;
    cancelAuto1;
    cancelAuto2;
    cancelAuto3;
    unAck;
    disable;
}

export class ActiveFlags {
    highHigh: ActiveFlagValue;
    high: ActiveFlagValue;
    lowLow: ActiveFlagValue;
    low: ActiveFlagValue;
    over: ActiveFlagValue;
    under: ActiveFlagValue;
    outputSensorBreak: ActiveFlagValue;
    feedbackError: ActiveFlagValue;
}

export class ActiveFlagValue {
    visible: boolean;
    level: AlarmLevel;
}

export class RangeSetting {
    color: string;
    min: number;
    max: number;
    enabled: boolean;
}

export class StatusSetting {
    color: string;
    statusString: string;
}

export class DisabledStatus {
    channelTag: string;
    status: 0 | 1;
    enabled: boolean;
}

export class FlashingStatus {
    channelTag: string;
    color: string;
    start: 0 | 1;
    finish: 0 | 1;
    enabled: boolean;
}

export class ToggleStatus {
    active: 0 | 1;
    inactive: 0 | 1;
}

export enum MimicAnimationOption {
    NONE = 'none',
    ALARM = 'alarm',
    CANCEL = 'cancel',
    UNACK = 'unack',

    ALARM_UNACK = 'alarm-unack',
    CANCEL_UNACK = 'cancel-unack',

    DIGITAL_NONE = 'digital-none',
}

export enum ButtonAction {
    Undefined = 'undefined',
    SET_CHANNEL = 'setChannel',
    TURN_ON = 'turnOn',
    TURN_OFF = 'turnOff',
    CHANGE_TO_RUN = 'changeToRun',
    CHANGE_TO_STOP = 'changeToStop',
    DISPLAY_CHANNEL = 'displayChannel',
}

export const presetColorKeys = {
    alarm: getColor('--mimic-alarm-color'),
    warn: getColor('--mimic-warn-color'),
    caution: getColor('--mimic-caution-color'),
    normal: getColor('--mimic-normal-color'),
    ack: getColor('--mimic-ack-color'),
    cancel: getColor('--mimic-cancel-color'),
    statusOn: getColor('--mimic-statusOn-color'),
    statusOff: getColor('--mimic-statusOff-color'),
    bar: getColor('--mimic-bar-color'),
};

function getColor(colorVar) {
    return getComputedStyle(document.body).getPropertyValue(colorVar);
}
